import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router";
import {handleSelectMultiple} from "./constants";
import Popper from "@mui/material/Popper";
import {
    ClickAwayListener,
    FormControlLabel,
    Grow,
    MenuList,
    Paper,
    Radio,
    RadioGroup,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {Svg} from "assets";
import {TextToolTip} from "./textToolTip";

export const MenuTool = ({handleFilter, handleClickSort, width, item}) => {
    const [open, setOpen] = React.useState(false);
    const [selected, setSelected] = React.useState(
        item?.defaultSelected ? item?.defaultSelected : "",
    );
    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    useEffect(() => {
        if (info && info[item?.name]) {
            setSelected(info[item?.name]);
        }
    }, [info]);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
    }

    const handleChange = (e) => {
        setSelected(e?.target?.value);
        handleFilter && handleFilter(e);
        setOpen(false);
    };

    return (
        <div style={width ? {width: width} : {}} className="filter-menu">
            <div className="search-input-title">
                <TextToolTip
                    classNameText="search-and-filer-text"
                    text={item?.title}
                    content={item?.title}
                    onClick={() => handleClickSort(item?.name)}
                />

                <button
                    className="reset-btn"
                    ref={anchorRef}
                    aria-controls={open ? "menu-list-grow" : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    {[item?.name] ? <Svg.FilterSvg/> : <Svg.FilterSvg/>}
                </button>
            </div>

            <Popper
                className="popper-menu"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "center top" : "center bottom",
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    className="menu-list-box"
                                    autoFocusItem={open}
                                    id="menu-list-grow"
                                    onKeyDown={handleListKeyDown}
                                >
                                    {item?.filterList?.map((i, j) =>
                                        item?.multiple ? (
                                            <FormControlLabel
                                                className="checkbox-filter-wrapper"
                                                label={i.name}
                                                key={j}
                                                control={
                                                    <Checkbox
                                                        name={item?.name}
                                                        value={i.id}
                                                        checked={
                                                            info?.[item?.name]?.length
                                                                ? info?.[item?.name]?.includes(i?.id)
                                                                : selected?.length
                                                                    ? selected?.includes(i?.id)
                                                                    : i.id === "All"
                                                        }
                                                        icon={<Svg.CheckboxSvg/>}
                                                        checkedIcon={<Svg.CheckboxCheckedSvg/>}
                                                        onChange={(e) =>
                                                            handleSelectMultiple(e, navigate, info, selected)
                                                        }
                                                    />
                                                }
                                            />
                                        ) : (
                                            <RadioGroup
                                                row
                                                style={{margin: 0}}
                                                key={j}
                                                aria-label="position"
                                                name="position"
                                                defaultValue="top"
                                            >
                                                <FormControlLabel
                                                    onChange={(e) => handleChange(e, i.id)}
                                                    value={i.id}
                                                    name={item?.name}
                                                    control={
                                                        <Radio
                                                            style={{color: "#FFC107"}}
                                                            checked={
                                                                !selected && i.id === "All"
                                                                    ? true
                                                                    : selected === i.id
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    label={i.name}
                                                    labelPlacement="End"
                                                />
                                            </RadioGroup>
                                        ),
                                    )}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
};
